module.exports = __webpack_public_path__ + "img/icon-t2.7ad89e1f.png";